// extracted by mini-css-extract-plugin
export var card = "_mz-1";
export var summary = "_mz-0";
export var unreadDot = "_mz-2";